
import { defineComponent, computed } from "vue";
import { store } from "@/store";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "LabelMaterialsButton",
  setup() {
    const materials = computed<any>(() => store.getters.materials);
    const currentLabelMaterialId = computed<number>(() => store.getters.currentLabelMaterialId);
    const currentMaterial = computed<any>(() =>
      materials.value.find((material: any) => Number(material.id) === currentLabelMaterialId.value)
    );

    const showLabelMaterials = () => {
      store.dispatch(ActionTypes.SET_MODAL, "labelMaterials");
    };

    return {
      currentMaterial,
      showLabelMaterials,
    };
  },
});
